module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-3.75190189.png";